import { AlertCircle } from 'react-feather';
import type { ToastComponentProps } from './interfaces';
import * as Toast from './Toast.Base';
import styles from './style.module.css';

type Props = ToastComponentProps;

export const Info = (props: Props) => {
  return (
    <Toast.Base
      Icon={AlertCircle}
      iconClassName={styles.info}
      body={props.body}
      title={props.title} />
  );
};

Info.displayName = 'Toast.Info';